import { setupLayout } from 'common.js';
import { render } from "react-dom";
import 'jquery.js';
import 'jquery-components/bootstrap-dropdown';
import HotelSearchContainer from './compoments/HotelSearchContainer';
import { NewHotelSearchProps } from './compoments/HotelSearch';

/**
 * 
 * @param {NewHotelSearchProps} props
 */
export function setupNewHotelSearch(props) {
    const root = HotelSearchContainer(props);
    render(root, document.getElementById('new-hotel-search'));
}

export { setupLayout };
